import { useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Camera, ImagePlus, Loader2, X } from "lucide-react";
import { uploadImage, fileUrl } from "@/lib/api";
import { toast } from "sonner";

export const PhotoUpload = ({ value, onChange, label = "Foto", testId = "photo-upload" }) => {
  const cameraRef = useRef(null);
  const galleryRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (!file.type.startsWith("image/")) { toast.error("File harus berupa gambar"); return; }
    if (file.size > 10 * 1024 * 1024) { toast.error("Ukuran gambar maksimal 10MB"); return; }
    setUploading(true);
    try {
      const url = await uploadImage(file);
      onChange(url);
      toast.success("Foto berhasil diunggah");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Gagal mengunggah foto");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="grid gap-1.5" data-testid={testId}>
      <span className="text-sm font-medium">{label}</span>
      <input ref={cameraRef} type="file" accept="image/*" capture="environment" className="hidden" onChange={handleFile} data-testid={`${testId}-camera-input`} />
      <input ref={galleryRef} type="file" accept="image/*" className="hidden" onChange={handleFile} data-testid={`${testId}-gallery-input`} />

      {value ? (
        <div className="relative w-full overflow-hidden rounded-md border border-border">
          <img src={fileUrl(value)} alt="Foto" className="h-40 w-full object-cover" data-testid={`${testId}-preview`} />
          <button type="button" onClick={() => onChange("")} className="absolute right-2 top-2 rounded-full bg-black/60 p-1 text-white hover:bg-black/80" data-testid={`${testId}-remove`}>
            <X className="h-4 w-4" />
          </button>
        </div>
      ) : (
        <div className="flex h-40 w-full items-center justify-center rounded-md border border-dashed border-border bg-muted/30 text-xs text-muted-foreground">
          {uploading ? <Loader2 className="h-6 w-6 animate-spin text-primary" /> : "Belum ada foto"}
        </div>
      )}

      <div className="flex gap-2">
        <Button type="button" variant="secondary" size="sm" disabled={uploading} onClick={() => cameraRef.current?.click()} data-testid={`${testId}-camera-btn`}>
          <Camera className="mr-1 h-4 w-4" /> Kamera
        </Button>
        <Button type="button" variant="secondary" size="sm" disabled={uploading} onClick={() => galleryRef.current?.click()} data-testid={`${testId}-gallery-btn`}>
          <ImagePlus className="mr-1 h-4 w-4" /> Galeri
        </Button>
      </div>
    </div>
  );
};
